import React from 'react';
import isHotKey from 'is-hotkey';
import BlockAction from './components/BlockAction';
import { DlIcon, ExpandIcon, DeleteIcon } from '../../components/Icons';
import createStore from '../utils/createStore';
import makeBlockActionButton from '../utils/makeBlockActionButton';
import BlockTypes from '../../types/BlockTypes';
import BlockActionTypes from '../../types/BlockActionTypes';
import GutterBlockTypes, { BLOCK_ACTION_EVENT } from '../../types/GutterBlockTypes';
import download from '../utils/download';
var DOWNLOADABLE_BLOCKS = [BlockTypes.FILE, BlockTypes.IMAGE];
var DELETABLE_BLOCKS = [BlockTypes.CODES, BlockTypes.HINTS, BlockTypes.QUOTES, BlockTypes.TABLE, BlockTypes.INTEGRATION_TILE, BlockTypes.IMAGE_GALLERY, BlockTypes.EMBED_PLACEHOLDER, BlockTypes.EMBED, BlockTypes.DATABASE];
var EXPANDABLE_BLOCKS = [BlockTypes.EMBED, BlockTypes.IMAGE];
export default (function () {
  var store = createStore({
    blockActionClosing: null,
    showBlockAction: false,
    target: null,
    node: null,
    placement: null,
    forcedActions: []
  });

  var showBlockAction = function showBlockAction() {
    return store.updateItem('showBlockAction', true);
  };

  var hideBlockAction = function hideBlockAction() {
    return store.updateItem('showBlockAction', false);
  };

  var setBlockActionClosing = function setBlockActionClosing(key) {
    return store.updateItem('blockActionClosing', key);
  };

  return [{
    commands: {
      openBlockAction: function openBlockAction(editor, node, target) {
        var placement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'left-end';
        var forcedActions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var blockActionClosing = store.getItem('blockActionClosing');

        if (blockActionClosing === node.key) {
          setBlockActionClosing(null);
          return;
        }

        editor.command('highlightBlock', node).moveToRangeOfNode(node).command('updateGutterBlock', {
          nodeId: node.key,
          gutterBlockType: GutterBlockTypes.BLOCK_PRESENCE,
          priority: 0,
          origin: BLOCK_ACTION_EVENT
        });
        store.updateItem('node', node);
        store.updateItem('target', target);
        store.updateItem('placement', placement);
        store.updateItem('forcedActions', forcedActions);
        return showBlockAction();
      },
      closeBlockAction: function closeBlockAction(editor) {
        var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var doNotHighlightAndFocusOnClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        setBlockActionClosing(key);

        if (!doNotHighlightAndFocusOnClose) {
          editor.command('highlightBlock', null).moveFocusToStartOfBlock().focus();
        }

        editor.command('updateGutterBlock', {
          nodeId: key,
          gutterBlockType: GutterBlockTypes.BLOCK_PRESENCE,
          origin: BLOCK_ACTION_EVENT
        });
        return hideBlockAction();
      }
    },
    onKeyDown: function onKeyDown(event, editor, next) {
      var blockActionShown = store.getItem('showBlockAction');
      if (!blockActionShown) return next();

      if (isHotKey('backspace', event)) {
        next();
        return editor.command('closeBlockAction');
      }

      if (isHotKey('escape', event)) {
        event.preventDefault();
        event.stopPropagation();
        editor.moveFocusToStartOfBlock().command('closeBlockAction');
      }

      return next();
    },
    renderEditor: function renderEditor(props, editor, next) {
      return React.createElement(React.Fragment, null, next(), React.createElement(BlockAction, Object.assign({
        store: store
      }, props)));
    }
  }, makeBlockActionButton(BlockActionTypes.DOWNLOAD, {
    index: 3,
    type: BlockActionTypes.ACTION,
    icon: DlIcon,
    label: 'Download',
    canApply: function canApply(editor, store) {
      var node = store.getItem('forcedActions');
      return store.getItem('forcedActions').includes(BlockActionTypes.DOWNLOAD) || DOWNLOADABLE_BLOCKS.includes(node.type) || node.type === BlockTypes.IMAGE_GALLERY && node.nodes.size === 1;
    },
    onClick: function onClick(editor, node) {
      return download(node.data.get('url') || node.nodes.first().data.get('url'));
    }
  }), makeBlockActionButton(BlockActionTypes.EXPAND, {
    index: 5,
    type: BlockActionTypes.ACTION,
    icon: ExpandIcon,
    label: 'Expand',
    canApply: function canApply(editor, store) {
      return store.getItem('forcedActions').includes(BlockActionTypes.EXPAND) || EXPANDABLE_BLOCKS.includes(store.getItem('node').type);
    },
    onClick: function onClick(editor, node) {
      return editor.openLightbox(node);
    }
  }), makeBlockActionButton(BlockActionTypes.DELETE, {
    index: 5,
    type: BlockActionTypes.ACTION,
    icon: DeleteIcon,
    label: 'Delete',
    canApply: function canApply(editor, store) {
      return !editor.readOnly && (store.getItem('forcedActions').includes(BlockActionTypes.DELETE) || DELETABLE_BLOCKS.includes(store.getItem('node').type));
    },
    onClick: function onClick(editor, node) {
      if (node.type === BlockTypes.TABLE) {
        editor.removeTable(editor.getCurrentTableId());
      } else {
        editor.removeNodeByKey(node.key);
      }
    }
  })];
});